/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BinaryFileType } from '../models/binary-file-type';
import { getCarrierDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';
import { GetCarrierDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';
import { getConsigneeDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-consignee-delivery-note-combined-pdf';
import { GetConsigneeDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-consignee-delivery-note-combined-pdf';
import { getConsignorDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-consignor-delivery-note-combined-pdf';
import { GetConsignorDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-consignor-delivery-note-combined-pdf';

@Injectable({ providedIn: 'root' })
export class PdfService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getConsignorDeliveryNoteCombinedPdf()` */
  static readonly GetConsignorDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/consignor/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignor. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsignorDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteCombinedPdf$Response(params: GetConsignorDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getConsignorDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignor. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsignorDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsignorDeliveryNoteCombinedPdf(params: GetConsignorDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getConsignorDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getCarrierDeliveryNoteCombinedPdf()` */
  static readonly GetCarrierDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a carrier. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf$Response(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getCarrierDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a carrier. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getCarrierDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

  /** Path part for operation `getConsigneeDeliveryNoteCombinedPdf()` */
  static readonly GetConsigneeDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignee. The last page is the controls page.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsigneeDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf$Response(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    const obs = getConsigneeDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures, all images and the control page
   * as a consignee. The last page is the controls page.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsigneeDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsigneeDeliveryNoteCombinedPdf(params: GetConsigneeDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    const resp = this.getConsigneeDeliveryNoteCombinedPdf$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

}
